import React from "react";
import { t } from "@lingui/macro";
import { AppTile, i18n } from "idc-ui-react";
// Fluent IU
import { Stack, Text } from "@fluentui/react";

const AppList = ({ apps }) => {
  return (
    <Stack
      horizontal
      horizontalAlign="start"
      verticalAlign="center"
      styles={{
        root: {
          minHeight: 120,
          backgroundColor: "transparent",
          marginBottom: 16
        }
      }}
    >
      {apps.length ? (
        apps.map(app => <AppTile app={app} key={app.id} size="large" />)
      ) : (
        <Text variant="medium">{i18n._(t`You have no pinned apps.`)}</Text>
      )}
    </Stack>
  );
};

export default AppList;
